import { useEffect, useContext, useState } from 'react'
import { useAuth } from 'v2/hooks/useAuth'
import { UserContext } from 'v2/context/user'

import { useRouter } from 'next/dist/client/router'
import { useTranslation } from 'i18n'
import { useOrganization } from '../v2/context/organization'

export const useProtectedRoute = () => {
    const { calledMe, logoutUser, loadingMe } = useAuth()
    const { authenticatedUser } = useContext(UserContext)

    const [authCheckComplete, setAuthCheckComplete] = useState(false)
    useEffect(() => {
        if (calledMe && !loadingMe) {
            if (authenticatedUser) {
                return setAuthCheckComplete(true)
            }

            if (!authenticatedUser) {
                void logoutUser()
            }
        }
    }, [authenticatedUser, calledMe, loadingMe])
    return { authCheckComplete }
}

export const useAdminRoute = () => {
    const { calledMe, logoutUser, loadingMe } = useAuth()
    const { authenticatedUser } = useContext(UserContext)
    const { program } = useOrganization()
    const router = useRouter()

    const [authCheckComplete, setAuthCheckComplete] = useState(false)

    useEffect(() => {
        if (calledMe && !loadingMe) {
            if (authenticatedUser) {
                if (!authenticatedUser?.isSuperuser) {
                    void router.replace(
                        `${authenticatedUser.potentialUser.program?.urlFragment || program.urlFragment}/`
                    )
                } else {
                    return setAuthCheckComplete(true)
                }
            }

            if (!authenticatedUser) {
                void logoutUser()
            }
        }
    }, [authenticatedUser, calledMe, loadingMe])
    return { authCheckComplete }
}

export const useUnprotectedRoute = (redirectTo = `/`) => {
    const { calledMe, loadingMe } = useAuth()
    const { authenticatedUser } = useContext(UserContext)

    const router = useRouter()

    const [authCheckComplete, setAuthCheckComplete] = useState(false)
    useEffect(() => {
        if (calledMe && !loadingMe) {
            if (!authenticatedUser) {
                return setAuthCheckComplete(true)
            }

            if (authenticatedUser) {
                router.replace(redirectTo)
            }
        }
    }, [authenticatedUser, calledMe, loadingMe])
    return { authCheckComplete }
}

export const securityQuestionList = () => {
    const { t } = useTranslation(window.LANG_NS)
    return [
        {
            label: t('security_question_pet'),
            value: t('security_question_pet', {
                lng: 'en',
            }),
        },
        {
            label: t('security_question_mothers_maiden_name'),
            value: t('security_question_mothers_maiden_name', {
                lng: 'en',
            }),
        },
        {
            label: t('security_question_childhood_nickname'),
            value: t('security_question_childhood_nickname', {
                lng: 'en',
            }),
        },
        {
            label: t('security_question_oldest_cousin'),
            value: t('security_question_oldest_cousin', {
                lng: 'en',
            }),
        },
        {
            label: t('security_question_favorite_teacher'),
            value: t('security_question_favorite_teacher', {
                lng: 'en',
            }),
        },
        {
            label: t('security_question_third_grade'),
            value: t('security_question_third_grade', {
                lng: 'en',
            }),
        },
    ]
}
